export default function SimpleLogoStrip({blockInfo}) {
    if (!blockInfo) {
        return <></>
    }
    return (
        <div style={{backgroundColor: blockInfo?.backgroundColor, color: blockInfo?.textColor}}>
            <div className="mx-auto pb-8 px-6 lg:px-8">
              <div className='mx-auto max-w-7xl py-6 text-xl text-center'>
                {blockInfo?.headline}
              </div>
                <div className="grid grid-cols-2 gap-8 md:grid-cols-5 lg:grid-cols-6">
                    {blockInfo && blockInfo.logos.map((logo, index) => (
                        <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1" key={index}>
                            <img 
                                className="h-12" 
                                src={logo.url} 
                                alt={logo.title} 
                                loading='lazy'
                            />    
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
